/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev1_QuoteInputs */

const en_funnel_sq_rev1_quote = /** @type {(inputs: Funnel_Sq_Rev1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I get through my entire reading list on my commute now. I don't know how I studied without it.`)
};

const es_funnel_sq_rev1_quote = /** @type {(inputs: Funnel_Sq_Rev1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora avanzo con toda mi lista de lectura en el trayecto al campus. No sé cómo estudiaba antes de esto.`)
};

/**
* | output |
* | --- |
* | "I get through my entire reading list on my commute now. I don't know how I studied without it." |
*
* @param {Funnel_Sq_Rev1_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev1_quote = /** @type {((inputs?: Funnel_Sq_Rev1_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev1_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev1_quote(inputs)
	return en_funnel_sq_rev1_quote(inputs)
});